<template>
  <div class="recap-option-interim">
    <div class="recap-option-interim-content">
      <section class="recap-option-interim-icon">
        <QIcon name="fas fa-bolt" size="32px" color="secondary" />
      </section>
      <section class="recap-option-interim-body">
        <h3 class="recap-option-interim-title">
          {{ t("ETAB.PAGES.DEMANDS.CREATION.@PRICING_TOTAL_HT") }}
        </h3>
        <div class="recap-option-interim-price">
          {{ formattedPrice }}
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
  import { computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { NumericHelpers } from "@core/helpers";

  const props = defineProps({
    data: {
      type: [String, Object, Number],
      default: null,
    },
  });

  const { t } = useI18n();
  const priceFallback = "0,00 €";

  const formattedPrice = computed(() => {
    if (props.data && props.data.regular_price) {
      return NumericHelpers.formatNumberAsCurrency({
        number: props.data.regular_price,
      });
    }
    return priceFallback;
  });
</script>

<style lang="scss">
  .recap-option-interim {
    // Base styling from RecapOption
    border-radius: 4px;
    cursor: pointer;
    transition: all 300ms ease;
    box-shadow: $card-shadow;
    margin-bottom: 16px !important;
    margin: 5px auto;
    background: white;

    // Boost-like special styling
    box-shadow: 0 3px 4px rgba($secondary, 0.15);
    border-radius: 0;
    margin-left: -30px;
    margin-right: -30px;

    @media screen and (max-width: $breakpoint-xs-max) {
      margin-left: -8px;
      margin-right: -8px;
    }

    &:hover {
      background-color: $primary-ultra-light;
    }

    // Layout
    .recap-option-interim-content {
      display: flex;
      align-items: center;
    }

    .recap-option-interim-icon {
      padding: 10px 12px;
      color: $secondary;
    }

    .recap-option-interim-body {
      flex: 1;
      padding: 15px 8px;

      .recap-option-interim-title {
        font-size: 14px;
        color: $primary;
        margin: 0;
      }

      .recap-option-interim-price {
        font-size: 16px;
        font-weight: bold;
        color: $primary;
        margin: 0;
      }
    }
  }
</style>
